
















































































































import {Component, Mixins, Vue} from 'vue-property-decorator'
import {Action, Getter} from 'vuex-class'
import {AppConfig} from '@/config/app.config'
import {MapConfig} from '@/config/map.config'
import CargaCollection from '@/model/collection/CargaCollection'
import DeliveryRequest from '@/model/request/DeliveryRequest'
import Carga from '@/model/resource/Carga'
import CargaRequest from '@/model/request/CargaRequest'

@Component
export default class ComponentUsageSampleView extends Vue {
  AppConfig = AppConfig
  MapConfig = MapConfig

  filter = new DeliveryRequest()
  collection = new CargaCollection(this.filter, null, 3)
  model = new Carga()

  toPersist = new CargaRequest()

  uploadEvent(urls: string[]) {
    this.model.fotosComprovantes.push(...urls)
  }

  async mounted() {
    await this.collection.search()
    const id = this.collection.items[0].$id
    if (id) await this.model.find(id)
  }
}
